import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12482636"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "assertion-date" }
const _hoisted_2 = { class: "assertion-age" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "assertion-type" }
const _hoisted_5 = {
  key: 0,
  class: "count"
}
const _hoisted_6 = { class: "assertion-details" }
const _hoisted_7 = {
  key: 0,
  class: "assertion-value"
}
const _hoisted_8 = {
  key: 1,
  class: "assertion-place"
}
const _hoisted_9 = { class: "place-name" }
const _hoisted_10 = {
  key: 2,
  class: "assertion-site"
}
const _hoisted_11 = {
  key: 0,
  class: "attribution"
}

import { computed } from 'vue'
import { ItemType, PersonName } from '@/rd/ResearchDataModel'
import { useAssertionStore } from '@/rd/AssertionStore'
import { usePersonStore } from '@/rd/PersonStore'
import { usePlaceStore } from '@/rd/PlaceStore'
import { useSiteStore } from '@/rd/SiteStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { FuzzyDate } from '@/rd/FuzzyDate'
import { HistoricalDateFormat } from '@/rd/HistoricalDateEnums'
import { DurationUtil } from '@/util/LuxonUtil'
import { AssertionTypeIcons } from './AssertionTypeIcons'
import { Edit2Icon } from '@zhuowenli/vue-feather-icons'
import { ProfileUtils } from '@/manage/profiles/ProfileUtils'
import { ItemPermissions } from '@/gp/GroupAdminModel'
import UserLink from '@/manage/users/UserLink.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AssertionRow',
  props: {
  assertionId: String,
  baseDate: FuzzyDate,
  noAttrib: Boolean,
  noIcon: Boolean,
  count: Number,
  dimmed: Boolean,
  indented: Boolean,
},
  emits: [
  "click",
],
  setup(__props, { emit }) {

const props = __props;




const assertionStore = useAssertionStore()
const placeStore = usePlaceStore()
const siteStore = useSiteStore()
const dataGroupStore = useDataGroupStore()
const userStore = useUserStore()
const personStore = usePersonStore()

const assertion = computed(() => assertionStore.getAsyncAssertion(props.assertionId)?.data)
const age = computed(() => props.baseDate ? assertion.value?.date.date1?.diff(props.baseDate) : undefined)
const ageText = computed(() => age.value ? DurationUtil.toAge(age.value) : '')
const assertionTypeIcon = computed(() => AssertionTypeIcons.getIcon(assertion.value?.assertionType))
const typeIconClassRef = computed(() => assertionTypeIcon.value ? assertion.value!.assertionType : undefined )
const assertionValue = computed(() => 
  assertion.value?.assertionType == "Name" ? PersonName.getDisplayName(assertion.value?.value) : assertion.value?.value)
const place = computed(() => placeStore.trackAsyncPlace(assertion.value?.placeId)?.data)
const flagClass = computed(() => place.value?.countryCode ? "fi-" + place.value.countryCode.toLowerCase() : undefined)
const site = computed(() => siteStore.trackAsyncSite(assertion.value?.siteId)?.data)

const dataGroupRef = computed(() => dataGroupStore.getAsyncGroup(assertion.value?.groupId)?.data) // should be pre-loaded
const ownerRef = computed(() => userStore.getAsyncUser(dataGroupRef.value?.ownerId)?.data) // should be pre-loaded
const personRef = computed(() => assertion.value?.subjectType == ItemType.Person ? personStore.getAsyncPerson(assertion.value?.subjectId)?.data : undefined) // should be pre-loaded
const profileTypeRef = computed(() => ProfileUtils.getProfileType(personRef.value, dataGroupRef.value, ownerRef.value))
const profileTextRef = computed(() => ProfileUtils.getProfileSubtitle(profileTypeRef.value)?.toLowerCase())

const permissionsRef = computed(() =>  dataGroupStore.getAsyncPermissions(assertion.value?.groupId)?.data ?? ItemPermissions.None) // loaded by parent


return (_ctx: any,_cache: any) => {
  return (assertion.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["assertion", { dimmed: __props.dimmed, indented: __props.indented, ['no-icon']: __props.noIcon }])
      }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-unstyled assertion-fields",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click', props.assertionId)))
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(assertion.value.date.toString(_unref(HistoricalDateFormat).ShortDisplay)), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(ageText.value), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["assertion-type-icon", typeIconClassRef.value])
          }, [
            _createElementVNode("img", { src: assertionTypeIcon.value }, null, 8, _hoisted_3)
          ], 2),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(assertion.value.assertionType) + " ", 1),
            ((__props.count ?? 1) > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "(" + _toDisplayString(props.count) + ")", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (assertion.value.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(assertionValue.value), 1))
              : _createCommentVNode("", true),
            (assertion.value.placeId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (place.value?.countryCode)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["flag fi", flagClass.value])
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(place.value?.shortName ?? place.value?.name), 1)
                ]))
              : _createCommentVNode("", true),
            (assertion.value.siteId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(site.value?.description), 1))
              : _createCommentVNode("", true)
          ]),
          (!props.noAttrib)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createTextVNode(" Defined in a " + _toDisplayString(profileTextRef.value), 1),
                _createVNode(UserLink, {
                  "user-id": ownerRef.value?.id,
                  dimmed: ""
                }, null, 8, ["user-id"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})